import { createResource, createSignal, For, Show, type Component } from "solid-js";
import { Search as SearchIcon } from "lucide-solid";
import { api, type Snip } from "../lib/api";
import SnipCard from "../components/SnipCard";
import Spinner from "../components/Spinner";

async function searchSnips(q: string): Promise<Snip[]> {
  if (!q.trim()) return [];
  const { data, error } = await api.GET("/snips/search", {
    params: { query: { q } },
  });
  if (error) throw new Error("Arama başarısız");
  return data ?? [];
}

const Search: Component = () => {
  const [input, setInput] = createSignal("");
  const [query, setQuery] = createSignal("");
  const [results] = createResource(query, searchSnips);

  const submit = (e: Event) => {
    e.preventDefault();
    setQuery(input().trim());
  };

  return (
    <div class="mx-auto max-w-3xl px-4 py-6">
      <div class="mb-5 flex items-center gap-2">
        <SearchIcon size={20} class="text-primary" />
        <h1 class="m-0 text-lg font-semibold">Arama</h1>
      </div>

      <form onSubmit={submit} class="mb-5">
        <input
          type="search"
          value={input()}
          onInput={(e) => setInput(e.currentTarget.value)}
          placeholder="Snippet, başlık veya açıklama ara..."
          class="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-primary"
        />
      </form>

      <Show
        when={query()}
        fallback={
          <div class="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground">
            Aramaya başlamak için bir şeyler yazıp Enter'a bas.
          </div>
        }
      >
        <Show
          when={!results.loading}
          fallback={
            <div class="flex justify-center py-16">
              <Spinner size={28} />
            </div>
          }
        >
          <Show
            when={(results() ?? []).length > 0}
            fallback={
              <div class="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground">
                "{query()}" için sonuç bulunamadı.
              </div>
            }
          >
            <div class="flex flex-col gap-3">
              <For each={results()}>{(snip) => <SnipCard snip={snip} />}</For>
            </div>
          </Show>
        </Show>
      </Show>
    </div>
  );
};

export default Search;
